(function () {
  const form = document.getElementById('parts-finder-form');
  if (!form) return;

  const yearSelect    = document.getElementById('pf-year');
  const makeSelect    = document.getElementById('pf-make');
  const modelSelect   = document.getElementById('pf-model');
  const subSelect     = document.getElementById('pf-submodel');
  const findBtn       = document.getElementById('pf-submit');

  let fitmentData = {};

  // Fetch from theme assets
  const jsonUrl = window.__partsFinderDataUrl__;
  fetch(jsonUrl)
    .then(r => r.json())
    .then(data => {
      fitmentData = data;
      populateSelect(yearSelect, Object.keys(data).sort().reverse(), 'Year');
      yearSelect.disabled = false;
    })
    .catch(err => console.error('Parts Finder: failed to load fitment data', err));

  function populateSelect(select, options, placeholder) {
    select.innerHTML = `<option value="">Select ${placeholder}</option>`;
    options.forEach(opt => {
      const el = document.createElement('option');
      el.value = opt;
      el.textContent = opt;
      select.appendChild(el);
    });
  }

  function resetSelect(select, placeholder) {
    select.innerHTML = `<option value="">Select ${placeholder}</option>`;
    select.disabled = true;
  }

  yearSelect.addEventListener('change', function () {
    resetSelect(makeSelect, 'Make');
    resetSelect(modelSelect, 'Model');
    resetSelect(subSelect, 'Sub-model');
    findBtn.disabled = true;

    if (!this.value) return;
    const makes = Object.keys(fitmentData[this.value] || {}).sort();
    populateSelect(makeSelect, makes, 'Make');
    makeSelect.disabled = false;
  });

  makeSelect.addEventListener('change', function () {
    resetSelect(modelSelect, 'Model');
    resetSelect(subSelect, 'Sub-model');
    findBtn.disabled = true;

    const year = yearSelect.value;
    if (!this.value || !year) return;
    const models = Object.keys(fitmentData[year][this.value] || {}).sort();
    populateSelect(modelSelect, models, 'Model');
    modelSelect.disabled = false;
  });

  modelSelect.addEventListener('change', function () {
    resetSelect(subSelect, 'Sub-model');
    findBtn.disabled = true;

    const year  = yearSelect.value;
    const make  = makeSelect.value;
    if (!this.value || !year || !make) return;
    const subs = fitmentData[year][make][this.value] || [];
    populateSelect(subSelect, subs, 'Sub-model');
    subSelect.disabled = false;
  });

  subSelect.addEventListener('change', function () {
    findBtn.disabled = !this.value;
  });

    findBtn.addEventListener('click', function (event) {
    event.preventDefault();

    const year     = yearSelect.value;
    const make     = makeSelect.value;
    const model    = modelSelect.value;
    const submodel = subSelect.value;

    if (!year || !make || !model || !submodel) return;

    const params = new URLSearchParams({
      'q': make,
      'type': 'product',
      'filter.p.m.fitment.year': year,
      'filter.p.m.fitment.make': make,
      'filter.p.m.fitment.model': model,
      'filter.p.m.fitment.submodel': submodel
    });

    window.location.href = `/search?${params.toString()}`;
  });
})();
